var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myExam",style:(_vm.myStyle)},[_c('div',{attrs:{"id":"iframe-container"}},[_c('iframe',{attrs:{"src":"/exam/#/exam-manage/index","width":"100%","height":_vm.iframeHeight + 'px',"frameborder":"0","scrolling":"auto","id":"iframename","name":"iframename"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }